(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('detalleJornadaController', detalleJornadaController);


    detalleJornadaController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'logEmpleadosService', 'common', 'modals', 'userService'
    ];


    function detalleJornadaController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, logEmpleadosService, common, modals, userService ) {

        /* PUBLIC VARIABLES */
        var vm = this;
        var id = $stateParams.id;
        var screen = $stateParams.type; 
        var tabNumber = $stateParams.tabNumber; 
        var empleadoId = $stateParams.empleadoId; 
        vm.jornada = {}; 
        vm.modificaciones = [];
        vm.allowRegularizar = false; 
        vm.canApprove = true; 
        vm.estados = [
            'Activa', 'Finalizada', 'Aprobada', 'Aceptada', 'Rechazada', 'Archivada'
        ];
        vm.loaded = false; 
        vm.observaciones = {list: [], add: null}; 
        vm.newEfectivas = 0; 
        vm.newPresencia = 0; 
        vm.newDescanso = 0; 
        vm.orEfectivas = 0;
        vm.orPresencia = 0;
        vm.orDescanso = 0; 
        vm.fechaIni = null;
        vm.jornadaOrig = false;
        vm.cumpleModificaciones = false;
        vm.newInicio = null; 
        vm.newFin = null; 
       
        vm.showRegularizar = showRegularizar; 
        vm.regularizarCallback = regularizarCallback;
        vm.formatDateToHours = formatDateToHours; 
        vm.secondsToHoursAndMinutes = secondsToHoursAndMinutes; 
        vm.save = save; 
        vm.aprobar = aprobar;
        vm.cancelar = cancelar; 
        vm.showMap = showMap; 
        vm.actualize = actualize; 
        vm.addObservacion = addObservacion; 
        vm.eliminarDetalle = eliminarDetalle; 
        vm.getHours = getHours; 
        vm.changeToOrig = changeToOrig; 
        vm.filtrarOtras = filtrarOtras; 

        (function () {
            loadData();
        })();

        function loadData() {
            console.log('asdf');
            if (userService.userData.empresamaster.contrataControlHorario != true) $state.go('flota.controlHorario.activarControlHorario');

            logEmpleadosService.getById(id).then(function (response) {
                vm.jornada = response; 
                vm.original = vm.jornada.original; 
                vm.jornada.estadoDescripcion = vm.estados[vm.jornada.estado];  
                vm.allowRegularizar = vm.jornada.estado == 1 || vm.jornada.estado == 4; 
                vm.canApprove = userService.userData.usuarioId == vm.jornada.empleado.usuarioId; 
                vm.modificaciones = vm.jornada.registroJornadaDetalles.filter(x=> x.duracion != 0);
                parseObservaciones(vm.observaciones, vm.jornada.observaciones); 
                vm.loaded = true; 
                vm.cumpleModificaciones = (vm.jornada.estado == 1 || vm.jornada.estado == 4 )&& vm.jornadaOrig == false;
                
                if(vm.jornada.estado == 1) {
                    vm.fechaIni = vm.jornada.registroJornadaDetalles[0].fechaIni;
                    calcularOriginales();              
                 }
                else {
                     vm.orEfectivas = vm.jornada.horas.efectivas;
                     vm.orDescanso = vm.jornada.horas.descanso;
                     vm.orPresencia = vm.jornada.horas.presencia;
                }
                vm.newInicio = vm.jornada.hInicio;
                vm.newFin = vm.jornada.hFin;
                vm.newEfectivas = vm.jornada.horas.efectivas;
                vm.newDescanso = vm.jornada.horas.descanso;
                vm.newPresencia = vm.jornada.horas.presencia;
            });
        }

        function actualize() {
            vm.loaded = false;
           loadData(); 
        }

        function changeToOrig() {
            vm.cumpleModificaciones = vm.jornadaOrig == true ? false : true; 
        }

        function showMap(lat, long) {
            if (lat == null || long == null) sendErrorNotification();
            else modals.showModal('showMap', {
                lat: lat,
                lng: long
            });
        }

        function getHours(num) {
            if(vm.jornadaOrig == false) {
                if(num == 0) return secondsToHoursAndMinutes(vm.newEfectivas);
                else if (num == 1) return secondsToHoursAndMinutes(vm.newPresencia);
                else if(num == 2) return secondsToHoursAndMinutes(vm.newDescanso);
            }
            else{
                 if (num == 0) return secondsToHoursAndMinutes(vm.orEfectivas);
                 else if (num == 1) return secondsToHoursAndMinutes(vm.orPresencia);
                 else if (num == 2) return secondsToHoursAndMinutes(vm.orDescanso);
            }
        }

        function showRegularizar(option, idx) {
            modals.showModal('regularizar', vm.regularizarCallback, {
                option: option,
                index: idx,
                tipoEmpleado: vm.jornada.empleado.tipoEmpleado,
                fechaIni: vm.fechaIni
            });
        }

        function regularizarCallback(hIni, hFin, estado, observaciones, duracion, idx, accion) {
            vm.original = false; 
            if(idx != undefined) {
                vm.modificaciones[idx].duracion = duracion; 
                vm.modificaciones[idx].fechaIni = hIni;
                vm.modificaciones[idx].fechaFin = hFin;
                vm.modificaciones[idx].observaciones = observaciones;
                vm.modificaciones[idx].accion = accion;
                vm.modificaciones[idx].prioritario = true; 
            }
            else {
                vm.modificaciones.push({
                    duracion: duracion,
                    fechaFin: hFin,
                    fechaIni: hIni,
                    grupoEstadoEmpleadoId: estado.grupoEstadoEmpleadoId,
                    observaciones: observaciones,
                    registroJornadaDetalleId: -1,
                    registroJornadaId: estado.registroJornadaId,
                    grupoEstadoEmpleado: estado,
                    usuarioId: null, 
                    accion: 1, 
                    registroJornadaId: vm.jornada.registroJornadaId, 
                    prioritario: true, 
                    original: false
                })
            }
            vm.modificaciones.sort(function(a,b){
                return new Date(a.fechaIni) - new Date(b.fechaIni); 
            }); 
            recalcularDetalles(); 
        }
        
         function eliminarDetalle(idx) {
            vm.original = false;
            if(idx != 0 && idx != vm.modificaciones.length-1) {
                vm.modificaciones[idx-1].fechaFin = vm.modificaciones[idx].fechaFin;
                vm.modificaciones[idx-1].accion = vm.modificaciones[idx-1].accion == 1 ? 1 : 2;  
                vm.modificaciones[idx - 1].duracion = getDuracion(vm.modificaciones[idx - 1].fechaIni, vm.modificaciones[idx - 1].fechaFin);
            }
            vm.modificaciones.splice(idx, 1); 
            recalcularTiempos(); 
         }

        function recalcularDetalles() {
            var prio = vm.modificaciones.findIndex(x=> x.prioritario); 
            vm.modificaciones[prio].prioritario = false; 
            console.log('asdf');
            if (prio != vm.modificaciones.length - 1) {
                vm.modificaciones[prio + 1].fechaIni = vm.modificaciones[prio].fechaFin;
                vm.modificaciones[prio + 1].duracion = getDuracion(vm.modificaciones[prio + 1].fechaIni, vm.modificaciones[prio + 1].fechaFin);
                vm.modificaciones[prio + 1].accion = vm.modificaciones[prio + 1].accion == 1 ? 1 : 2;
            }
            if (prio != 0) {
                if (vm.modificaciones[prio].fechaFin < vm.modificaciones[prio - 1].fechaFin) {
                    vm.modificaciones.splice(prio + 1, 0,
                        {
                            fechaIni: vm.modificaciones[prio].fechaFin,
                            fechaFin: vm.modificaciones[prio - 1].fechaFin,
                            duracion: getDuracion(vm.modificaciones[prio - 1].fechafin, vm.modificaciones[prio].fechaFin),
                            accion: vm.modificaciones[prio - 1].accion
                        });
                }
                vm.modificaciones[prio-1].fechaFin = vm.modificaciones[prio].fechaIni; 
                vm.modificaciones[prio -1].duracion = getDuracion(vm.modificaciones[prio - 1].fechaIni, vm.modificaciones[prio - 1].fechaFin);
                vm.modificaciones[prio - 1].accion = vm.modificaciones[prio - 1].accion == 1 ? 1 : 2;

            }
            var idx = prio+1; 
            var flag = true; 
            while(idx < vm.modificaciones.length && flag) {
                if(moment(vm.modificaciones[idx].fechaFin) < moment(vm.modificaciones[prio].fechaFin)) {
                    vm.modificaciones.splice(idx, 1); 
                    --idx;  
                }//eliminar estado 
                else {
                    flag = false; 
                }
                ++idx; 
            }

            recalcularTiempos(); 
        }

        function recalcularTiempos() {
            vm.newEfectivas = 0; 
            vm.newPresencia = 0; 
            vm.newDescanso = 0; 
            for(var i = 0; i < vm.modificaciones.length; i++) {
                var estado = vm.modificaciones[i].grupoEstadoEmpleadoId; 
                if(estado == 0) vm.newPresencia += vm.modificaciones[i].duracion; 
                else if(estado == 1 || estado == 2) vm.newEfectivas += vm.modificaciones[i].duracion; 
                else if(estado == 3) vm.newDescanso += vm.modificaciones[i].duracion; 
            }
            vm.newInicio = vm.modificaciones.length != 0 ? moment(vm.modificaciones[0].fechaIni).format('HH:mm') : '--:--';  
            vm.newFin = vm.modificaciones.length != 0 ? moment(vm.modificaciones[(vm.modificaciones.length-1)].fechaFin).format('HH:mm') : '--:--';

        } 

        function calcularOriginales() {
            vm.orEfectivas = 0;
            vm.orPresencia = 0;
            vm.orDescanso = 0;
            for (var i = 0; i < vm.jornada.registroJornadaDetalles.length; i++) {
                if(vm.jornada.registroJornadaDetalles[i].original == true) {
                    var estado = vm.jornada.registroJornadaDetalles[i].grupoEstadoEmpleadoId;
                    if (estado == 0) vm.orPresencia += vm.jornada.registroJornadaDetalles[i].duracionOrig;
                    else if (estado == 1 || estado == 2) vm.orEfectivas += vm.jornada.registroJornadaDetalles[i].duracionOrig;
                    else if (estado == 3) vm.orDescanso += vm.jornada.registroJornadaDetalles[i].duracionOrig;
                }
            }
        }

        function getDuracion(ini, fin) {
            var difference = moment(fin).diff(moment(ini), 'seconds');
            return difference;
        };

        function formatDateToHours(date) {
            if (date == null) return "--:--";
            return moment(date).format('HH:mm');
        }

        function compare(a, b) {
            if (a.fechaIni < b.fechaIni) {
                return -1;
            }
            if (a.fechaIni > b.fechaIni) {
                return 1;
            }
            return 0;
        }

        function save() {
            var modifi = []; 
            for(var i = 0; i < vm.modificaciones.length; i++) {
                modifi.push({
                    GrupoEstadoEmpleadoId: vm.modificaciones[i].grupoEstadoEmpleadoId,
                    RegistroJornadaId: vm.modificaciones[i].registroJornadaId, 
                    FechaIni: new Date(vm.modificaciones[i].fechaIni),
                    FechaFin: new Date(vm.modificaciones[i].fechaFin),
                    Duracion: vm.modificaciones[i].duracion,
                    Observaciones: vm.modificaciones[i].observaciones, 
                    RegistroJornadaDetalleId: vm.modificaciones[i].registroJornadaDetalleId, 
                    Accion: vm.modificaciones[i].accion
                });
            }
            logEmpleadosService.save(modifi, vm.jornada.observaciones, vm.jornada.registroJornadaId).then(function() {
                sendSAveNotification();
                cancelar();
            });
        }

        function secondsToHoursAndMinutes(seconds) {
            var horas = ""; 
            if(seconds < 0) {
                horas = "-";
            }
            horas += Math.abs(Math.trunc(seconds / 3600)).toString() + " h ";
            var minutes = Math.abs(Math.round((seconds % 3600) / 60)).toString() + " min";
            return horas + minutes;

        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'La jornada se ha guardado correctamente',
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function sendAprobarNotification() {
            notificationService.sendAppNotification({
                message: 'La jornada se ha guardado y aprobado correctamente',
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function sendErrorNotification() {
            notificationService.sendAppNotification({
                message: 'La ubicación del empleado en ese momento no está disponible',
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function aprobar() {
            var lista = [];
             var modifi = [];
             for (var i = 0; i < vm.modificaciones.length; i++) {
                 modifi.push({
                     GrupoEstadoEmpleadoId: vm.modificaciones[i].grupoEstadoEmpleadoId,
                     RegistroJornadaId: vm.modificaciones[i].registroJornadaId,
                     FechaIni: new Date(vm.modificaciones[i].fechaIni),
                     FechaFin: new Date(vm.modificaciones[i].fechaFin),
                     Duracion: vm.modificaciones[i].duracion,
                     Observaciones: vm.modificaciones[i].observaciones,
                     RegistroJornadaDetalleId: vm.modificaciones[i].registroJornadaDetalleId,
                     Accion: vm.modificaciones[i].accion
                 });
             }
            lista.push(vm.jornada.registroJornadaId);
              logEmpleadosService.save(modifi, vm.jornada.observaciones, vm.jornada.registroJornadaId).then(function () {
                  sendSAveNotification();
                    logEmpleadosService.aprobar(lista).then(function () {
                        sendAprobarNotification();
                        cancelar();
                });
            });
            
        }

        function cancelar() {
            console.log(empleadoId); 
            $state.go('flota.controlHorario.fichajes', {
                'tabNumber': tabNumber, 
                'empleadoId': empleadoId
            });
        }


          function parseObservaciones(obs, data) {
              if (data == null) {
                  obs.list = [];
              } else {
                  try {
                      obs.list = JSON.parse(data);
                  } catch (e) {
                      data = JSON.stringify([{
                          text: data
                      }]);
                      obs.list = JSON.parse(data);
                  }
              }
          }

          function addObservacion(obs) {
              if (!obs.add) {
                  return;
              }
              obs.list.push({
                  text: obs.add,
                  time: Date.now(),
                  author: userService.userData.name ? userService.userData.name : '' +
                      (userService.userData.surname ? ' ' + userService.userData.surname : '')
              });
              obs.add = null;

                vm.jornada.observaciones = JSON.stringify(vm.observaciones.list);
              
          }

          function filtrarOtras(obj) {
              if(obj.duracion == 0)return false; 
              return true; 
          }


    }
})();
